import React from 'react';

const Input = input => {
  let markup = null;
  switch (input.type) {
    case 'email':
    case 'text':
    case 'submit':
      markup = <input {...input} />;
    break;
    case 'textarea':
      markup = <textarea {...input} />;
    break;
    default:
    break;
  }
  return markup;
};

Input.propTypes = {
  type: React.PropTypes.string.isRequired
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Form/Input.js